
import ApiOrderItem from 'types/api/OrderItem';

import Currency from 'models/Currency';
import Location from 'models/Location';
import Model from 'models/Model';
import Product from 'models/Product';
import User from 'models/User';
import Voucher from 'models/Voucher';

import { changeFromCent, displayPrice } from 'utils/math';

export enum ProductTypes {
    Product = 'product',
    Offer = 'offer',
    Voucher = 'voucher',
    Bundle = 'bundle',
}

export default class OrderItem implements Model {
    id: string;
    productType: ProductTypes;
    productId: string;
    productName: string;
    quantity: number;
    price: number;
    priceDisplay: string;
    originalPrice: number;
    originalPriceDisplay: string;
    discountValue: number;
    discountValueDisplay: string;
    discountCodeValue: number;
    discountCodeValueDisplay: string;
    currency: Currency;
    user: User;
    product: Product | Voucher;
    location: Location;

    constructor(data: ApiOrderItem) {
        this.id = data.id;
        this.currency = data.currency && new Currency(data.currency);
        this.productType = data.productType;
        this.productId = data.productId;
        this.productName = data.productName;
        this.product = data.product && (data.productType === ProductTypes.Voucher ? new Voucher(data.product) : new Product(data.product));
        this.quantity = data.quantity;
        this.price = changeFromCent(data.price);
        this.priceDisplay = displayPrice(this.price, this.currency);
        this.originalPrice = changeFromCent(data.originalPrice);
        this.originalPriceDisplay = displayPrice(this.originalPrice, this.currency);
        this.discountValue = changeFromCent(data.discountValue);
        this.discountValueDisplay = displayPrice(this.discountValue, this.currency);
        this.discountCodeValue = changeFromCent(data.discountCodeValue);
        this.discountCodeValueDisplay = displayPrice(this.discountCodeValue, this.currency);
        this.user = data.user && new User(data.user);
        this.location = data.location && new Location(data.location);
    }
}